import { useState, useLayoutEffect } from "react";

export const useScrollLock = (isLockRequested: boolean) => {
  const [originalStyle, setOriginalStyle] = useState("");

  useLayoutEffect(() => {
    if (isLockRequested) {
      setOriginalStyle(window.getComputedStyle(document.body).overflow);
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = originalStyle;
    }

    return () => (document.body.style.overflow = originalStyle);
  }, [isLockRequested]);
};
